import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Department Master', screenId: '4.3.2', module: 'Procurement', apiPath: 'department', screenName: 'DepartmentMaster', idField: 'SDMUId', nameField: 'SDMName',
  gridColumns: [{ field: 'SDMUId', header: 'Department ID' }, { field: 'SDMName', header: 'Department Name' }, { field: 'Location', header: 'Location' }],
  formFields: [{ field: 'SDMUId', label: 'Department Id', disabled: true }, { field: 'SDMName', label: 'Department Name', required: true }, { field: 'Location', label: 'Location' }]
});
